import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { Azienda, Company, Environment, GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';
import { UserInfo } from '../login/login.service';



@Injectable({
  providedIn: 'root'
})
export class UserService {

  private e_invoiceUrl: string = environment.url;
  //private e_invoiceUrl: string = AppConfig.settings.apiServer.url;

  constructor(private http: HttpClient) { }

  async getManagedUsersTable(id: number | string, params: HttpParams): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + id + "/managed_users", { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      })

  }

  async getManagedUserById(id: number | string, managedId: number | string): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + id + "/managed_users/" + managedId)
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }
  async getAdmins(id: number | string, params: HttpParams): Promise<UserInfo[]> {
    params = params.delete('searchFilter');
    params = params.append('searchFilter', '{\"role\":\"A\"}');
    params = params.append('pageSize', 1000);
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + id + "/managed_users", { params: params })
      .toPromise()
      .then((data: any) => {
        return data.data.data;
      })
  }
  async getResellers(id: number | string, params: HttpParams): Promise<UserInfo[]> {
    params = params.delete('searchFilter');
    params = params.append('searchFilter', '{\"role\":\"R\"}');
    params = params.append('pageSize', 1000);
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + id + "/managed_users", { params: params })
      .toPromise()
      .then((data: any) => {
        return data.data.data;
      })
  }

  async getCompanyDoctypes(companyId: string): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + companyId + "/document_types/")
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async getCompanyInfo(companyId: string): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + companyId + "/info/")
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async getNewUser(): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/models/managed_user/")
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }

  async findServers(): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/findServer/")
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async getRoles(): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/users_roles/")
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async findCompanies(): Promise<GenericResponse> {
    return await this.http.get(this.e_invoiceUrl + "/api/v1/findAziende/")
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async cercaAziende(name: string): Promise<Company[]> {

    return await this.http.get(this.e_invoiceUrl + "/api/v1/findAziende/?searchFilter={\"company_name\":\"" + name + "\"}")
      .toPromise()
      .then((data: any) => {
        return data.data.data;
      });
  }

  async creaAzienda(azienda: Azienda, userId: string | number): Promise<GenericResponse> {
    return await this.http.post(this.e_invoiceUrl + "/api/v1/creaAzienda/" + userId, azienda)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async cercaAmbienti(name: string): Promise<Environment[]> {

    return await this.http.get(this.e_invoiceUrl + "/api/v1/findAziende/?searchFilter={\"environment\":\"" + name + "\"}")
      .toPromise()
      .then((data: any) => {
        return data.data.data;
      });
  }

  async saveUser(user: UserInfo, managerId: string | number): Promise<GenericResponse> {
    return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users/" + user.dms_user_id, user)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async disablePassive(user: UserInfo, managerId: string | number) : Promise<GenericResponse> {
    return await this.http.post(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users/" + user.dms_user_id + "/disable_passive", user)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async saveNewUser(user: UserInfo, managerId: string | number): Promise<GenericResponse> {
    return await this.http.post(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users", user)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async deleteUser(managerId: string | number, userId: string | number): Promise<GenericResponse> {
    return await this.http.delete(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users/" + userId)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async manageEnable(managerId: string | number, userId: string | number, setEnabled: boolean): Promise<GenericResponse> {
    let body = { 'enabled': setEnabled };
    return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users/" + userId + "/enabled", body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async manageUserStatus(managerId: string | number, userId: string | number, status: number): Promise<GenericResponse> {
    let body = { 'enabled': status };
    return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + managerId + "/managed_users/" + userId + "/enabled", body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }


  async resetPassword(userId: string | number): Promise<GenericResponse> {
    let body = { autogenerate: true, user_id: userId };
    return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + userId + "/password/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async changePassword(userId: any, body: any): Promise<GenericResponse> {
    return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + userId + "/managed_users/" + userId + "/password", body)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }


  async searchAddress(userId: string | number, params: HttpParams): Promise<GenericResponse> {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/addresses", { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async cercaRubrica(userId: string | number, params: HttpParams): Promise<GenericResponse> {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/rubrica/cerca", { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async getSezionali(userId: string | number): Promise<GenericResponse> {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/sezionali")
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        return[];
        // this.router.navigate(['../Login']);
      });
  }

  async getArticoliDisponibili(userId: string | number, params: HttpParams): Promise<GenericResponse> {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/articoli", { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async getSessionCountdown(einv_id: string) {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/auth/access_token/" + einv_id)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async to_xml(userId: string, body: any) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/to_xml", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async to_xml_pdf(userId: string, body: any) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/to_xml_pdf", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async to_xml_pdf_alt(userId: string, body: any) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/to_xml_pdf_alt", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async draft_invoices(userId: string, body: any) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/draft_invoices/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async compile_from_xml(userId: string, body: FormData) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/compile_from_xml", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async invoices_send(userId: string, body: any) {
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async invoices_update(userId: string, body: any) {
    return await this.http.put<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/", body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

  async download_no_signature(userId: string, idDoc: string) {
    return await this.http.get<GenericResponse>(this.e_invoiceUrl + "/api/v1/users/" + userId + "/invoices/" + idDoc + "/download_no_signature")
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
        // this.router.navigate(['../Login']);
      });
  }

}
